import axios from 'axios';
import * as config from '../config';


export const COMPANY_REQUEST  = "COMPANY_REQUEST";
export const COMPANY_SUCCESS  = "COMPANY_SUCCESS";
export const COMPANY_ERROR  = "COMPANY_ERROR";
export const COMPANY_CHANGE_COUNT  = "COMPANY_CHANGE_COUNT";
export const COMPANY_CHANGE  = "COMPANY_CHANGE";
export const COMPANY_FILTERS_RESET  = "COMPANY_FILTERS_RESET";
export const COMPANY_FILTERS_CHANGE  = "COMPANY_FILTERS_CHANGE";
export const COMPANY_OFFER_CHANGE = "COMPANY_OFFER_CHANGE";
export const COMPANY_RESET = "COMPANY_RESET";
export const COMPANY_RESET_DATA = "COMPANY_RESET_DATA";

export const COMPANY_UPLOAD_BINDINGS_REQUEST = "COMPANY_UPLOAD_BINDINGS_REQUEST";
export const COMPANY_UPLOAD_BINDINGS_RESULT = "COMPANY_UPLOAD_BINDINGS_RESULT";
export const COMPANY_REMOVE_BINDINGS = "COMPANY_REMOVE_BINDINGS";



export function Get(companyBindToId,id,offset,size,offerId="",filters){
    return(dispatch)=>{
        dispatch({
            type:COMPANY_REQUEST
        });


        let data  = new FormData();
        data.append("file",filters.file)
        data.append("companyBindTo",companyBindToId)
        data.append("companyId",id)
        data.append("offset",offset)
        data.append("size",size)
        data.append("offerId",offerId)
        data.append("bindingType",filters.bindingType)
        data.append("onlyAutoBinded",filters.onlyAutoBinded)

        axios.post(
              config.apiUrl + "/offers/bindingsbybarcodes", // новый метод
            //config.apiUrl + "/offersforcompany",
            data,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response)=>{
            dispatch({
                type:COMPANY_SUCCESS,
                payload:response.data.content
            })
        }).catch((error)=>{
            dispatch({
                type:COMPANY_ERROR
            })
        })

    }
}

export function ChangeCount(count){
    return (dispatch) =>{
        dispatch({
            type:COMPANY_CHANGE_COUNT,
            payload:count
        })
    }
}

export function Change(field,value){
    return (dispatch) =>{
        dispatch({
            type:COMPANY_CHANGE,
            payload:{
                field,
                value
            }
        })
    }
}

export function FiltersChange(filters){
    return (dispatch) =>{
        dispatch({
            type:COMPANY_FILTERS_CHANGE,
            payload:filters
        })
    }
}

export function FiltersReset() {
    return (dispatch) =>{
        dispatch({
            type:COMPANY_FILTERS_RESET
        })
    }
}


export function Reset(){
    return (dispatch) =>{
        dispatch({
            type:COMPANY_RESET
        })
    }
}

export function ResetData(){
    return (dispatch) =>{
        dispatch({
            type:COMPANY_RESET_DATA
        })
    }
}

export function OfferChange(offer){
    return (dispatch) =>{
        dispatch({
            type:COMPANY_OFFER_CHANGE,
            payload:offer
        })
    }

}

export function RemoveBindings(data){ //data - массив объектов привязок
    return (dispatch) =>{
        axios.post(
            config.apiUrl + "/offers/deletebindings",
            data
        )
        .then((response)=>{
            dispatch({
                type:COMPANY_REMOVE_BINDINGS
            })
        })
    }
}

export function UploadBindings(file){
    return(dispatch) => {
        dispatch({
            type:COMPANY_UPLOAD_BINDINGS_REQUEST
        });
        let data  = new FormData();
        data.append("file",file)

        axios.post(
            config.apiUrl + "/offers/uploadbindings", // новый метод
          
          data,
          {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          }
      ).then((response)=>{
        dispatch({
            type:COMPANY_UPLOAD_BINDINGS_RESULT,
            payload:response.data.content
        })
    })
    }

}


// WEBPACK FOOTER //
// ./src/actions/companyActions.js